import { useQuery } from "@tanstack/react-query";
import { apiJson } from "@/lib/api-client";

export interface AccountData {
  equity: number;
  free: number;
  used: number;
  safe_factor: number | null;
  account_leverage: number;
  margin_pct: number;
  long_notional: number;
  short_notional: number;
  net_exposure: number;
  exposure_suppressed_side: "buy" | "sell" | null;
}

export function useAccount() {
  return useQuery<AccountData>({
    queryKey: ["account"],
    queryFn: () => apiJson<AccountData>("/account"),
    refetchInterval: 30000,
  });
}
